import React from 'react'
import "../assests/contact.css"

function Contact() {
  return (
    <>
     <div className="work">
      <h1>
      Talk to 
      <span style={{color:"#32BAC7"}}>
        {' '}
       us
      </span>
      </h1>
     </div>
     <div className="work-details">
      <p>
      Cursus nibh potenti feugiat sed enim suspendisse donec leo. Non blandit egestas metus, 
      duis tellus gravida.Cursus nibh potenti feugiat sed enim suspendisse donec leo
      </p>
     </div>
     {/* <button className="book-appointment">
      Book Appointment
     </button> */}
    </>
  )
}

export default Contact